<template>
    <div>
        <div class="slot-lab">Что ещё умеет Data Heroes</div>
        <div class="cards">
            <div v-for="card in cards" :key="card.name" :class="['card', { pro: card.pro }]">
                <div class="ico">
                    <v-icon size="19">{{ mdiIcon(card.icon) }}</v-icon>
                </div>
                <div class="c-name-row">
                    <span class="c-name">{{ card.name }}</span>
                    <span v-if="card.pro" class="pro-tag">PRO</span>
                </div>
                <div class="c-desc">{{ card.description }}</div>
                <button v-if="!card.noLearn" type="button" class="learn" @click="$emit('learn', card)">
                    Узнать больше
                    <span class="learn__arrow"><ArrowRightXsIcon /></span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import ArrowRightXsIcon from '@/assets/vuetifyIcons/arrowRightXs.vue'
import { mdiIcon } from '../utils/scenarioUi'

export default {
    name: 'StarterPackInfoCards',
    components: { ArrowRightXsIcon },
    props: {
        cards: {
            type: Array,
            required: true,
        },
    },
    methods: {
        mdiIcon,
    },
}
</script>

<style lang="scss" scoped>
@import '@/vars.sass';

.slot-lab {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 14px;
    color: $muted-light-new;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.09em;
    text-transform: uppercase;
}

.slot-lab::after {
    flex: 1;
    height: 1px;
    background: $border-new;
    content: '';
}

.cards {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
    margin-bottom: 36px;
}

.card {
    display: flex;
    flex-direction: column;
    gap: 11px;
    padding: 18px 16px 16px;
    background: #fff;
    border: 1px solid $border-new;
    border-radius: 13px;
}

.ico {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: #f4f6fa;
    border: 1px solid $border-light-new;
    border-radius: 10px;
}

.ico ::v-deep .v-icon {
    color: #7a8294;
}

.c-name-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 7px;
}

.c-name {
    color: $dark-new;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 14px;
    font-weight: 700;
}

.c-desc {
    flex: 1;
    color: $muted-new;
    font-size: 12px;
    line-height: 1.4;
    overflow-wrap: anywhere;
}

.pro-tag {
    padding: 2px 6px;
    color: #1a1800;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 8.5px;
    font-weight: 800;
    background: $pop-new;
    border-radius: 5px;
}

.learn {
    display: inline-flex;
    align-self: flex-start;
    align-items: center;
    gap: 5px;
    padding: 4px 10px;
    color: $main-new;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 10.5px;
    font-weight: 700;
    background: $bcg-card-new;
    border: 0;
    border-radius: 999px;
    cursor: pointer;
    transition: background 0.15s, transform 0.1s;

    &:hover {
        background: #e2e6fc;
    }

    &:active {
        background: #d4daf8;
        transform: scale(0.97);
    }
}

.learn__arrow {
    display: inline-flex;
    flex-shrink: 0;
    color: inherit;
    line-height: 0;
}

.learn__arrow ::v-deep svg {
    width: 11px;
    height: 11px;
    display: block;
}

.learn__arrow ::v-deep svg path:last-child {
    display: none;
}

.card.pro {
    background: $dark-new;
    border-color: $dark-new;
}

.card.pro .ico {
    background: rgba(82, 90, 213, 0.22);
    border-color: rgba(82, 90, 213, 0.32);
}

.card.pro .ico ::v-deep .v-icon {
    color: $pop-new !important;
}

.card.pro .c-name {
    color: #fff;
}

.card.pro .c-desc {
    color: rgba(255, 255, 255, 0.6);
}

.card.pro .learn {
    color: $pop-new;
    background: rgba(212, 236, 56, 0.16);

    &:hover {
        background: rgba(212, 236, 56, 0.26);
    }

    &:active {
        background: rgba(212, 236, 56, 0.34);
        transform: scale(0.97);
    }
}

@media (max-width: 1024px) {
    .cards {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 760px) {
    .cards {
        grid-template-columns: 1fr;
    }
}
</style>
